"use strict"

import { reportInstance as API } from "@/plugins/hylable-sdk"

export default {
  async discussion({cid, id, format, lang, reportname, filetype}){
    const params = { filetype, reportname }
    if(format) params.reportformat = format
    if(lang) params.reportlang = lang
    const res = await API.get(`/course/${cid}/discussion/${id}`, undefined, params)
    const b64 = await res.text()
    return b64toBlob(b64, `application/${filetype}`)
  },
}

function b64toBlob(b64, type) {
  const binaryString = window.atob(b64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return new Blob([bytes], { type })
}
